module.exports = __webpack_public_path__ + "img/l5.3f93e686.png";